import { gql } from '@apollo/client';

export function updateDescriptionOfRisk() {
  return gql`
    mutation modifyPolicyDescription(
      $entityId: String!
      $descriptionOfRisk: String
      $geoLocation: String
    ) {
      production {
        entities {
          policy {
            production {
              modifyPolicyDescription(
                entityId: $entityId
                descriptionOfRisk: $descriptionOfRisk
                geoLocation: $geoLocation
              )
            }
          }
        }
      }
    }
  `;
}
